<template>
  <div class="signup-wall">
    <div class="absolute">
      <div class="fadeout"></div>
      <div class="text-blocker">
        <div class="grey-card">
          <div>
            <h3 style="color: #262626; font-size: 21px;">Få flere muligheder med en gratis profil</h3>
            <p class="sub-title" style="font-weight: 500;">Opret en profil og få større indsigt<br/> i dansk erhvervsliv.</p>
          </div>
          <LassoxLink :path="path" trackingEventName="signup+wall+click">
            <Button theme="peach" label="Opret gratis profil"></Button>
          </LassoxLink>
          <span class="login" style="font-weight: 500;">Har du allerede en konto?
            <LassoxLink initialRoute="login" :path="path" trackingEventName="signup+wall+click">Log ind her</LassoxLink>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import userStore from '@/modules/users/store'
import Button from '@/components/Button.vue'
import LassoxLink from '@/components/LassoxLink.vue';
import { lassoxPortalUrl } from '@/lasso-urls';

export default {
  props: {
    'path': {
      type: String,
      required: true
    },
  },
  components: {
    Button,
    LassoxLink
  },
  data() {
    return {}
  },
  computed: {
    previewContent: function () {
      return this.newsItem.content.replace(new RegExp('/li>', 'g'), '/li>, ').replace(/<[^>]*>/g, '')
    },

    isLoggedIn() {
      return !!userStore.user
    },
  },
}
</script>

<style lang="less" scoped>
@import (reference) "~@oldShared/lasso/style/constants/colors";

.signup-wall {
  position: relative;

  .absolute {
    position: absolute;
    transform: translateY(-100%);
    width: 100%;

    .fadeout {
      height: 78px;
      // position: relative;
      z-index: 1;
      background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
    }

    .text-blocker {
      background: white;
    }

    .grey-card {
      background-color: #F1F1F1;

      border-radius: 16px;
      text-align: center;

      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 24px;
      padding: 24px 8px 24px 8px;

      h3 {
        font-size: 22px;
        font-weight: 600;
      }

      .sub-title {
        margin-top: 16px;
      }

      .login {
        font-size: 13px;
      }
    }
  }
}
</style>
